import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import Card from "@/components/wpl/card/src";

import { JiraServiceManagementTemplateMessageMap } from "../../../../templates/software/jira/templates/service-management/jira-templates-page/src/content/templates-grid-content-intl";

import type { Template } from "../../../..//content/templates/template.types";

export interface TemplateCardProps {
    template: Template;
}

const containerStyles = css({
    // Overriding default card styles to match JSM templates
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".text-section": {
        padding: "32px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "h4": {
        color: "#253858 !important",
        fontSize: "1.25rem !important",
        lineHeight: "1.2rem !important",
        marginBlockEnd: "16px !important"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "p": {
        color: "#253858 !important",
        fontSize: "1rem !important",
        lineHeight: "1.5rem !important",
        marginBlockEnd: "0 !important"
    },
    "boxShadow": "1px 1px 6px rgba(0,0,0,.1) !important",
    "transition": "box-shadow 0.2s ease-in",
    "&:hover": {
        boxShadow: "0 4px 12px rgba(0,0,0,.25) !important"
    },
    "&:focus": {
        borderColor: "rgb(9, 30, 66) 2px !important"
    },
    "borderRadius": "3px !important",
    "overflow": "hidden",
    "tabindex": "0 !important"
});

export const TemplateCard = ({ template }: TemplateCardProps) => {
    const intl = useIntl();

    const url = template.urlSlug
        ? `/software/jira/templates/${template.urlSlug}`
        : "";

    const messages =
        JiraServiceManagementTemplateMessageMap[template.templateId];

    if (messages) {
        return (
            <a href={url ?? ""} css={containerStyles}>
                <Card
                    className="template-card"
                    data-test-id="template-card"
                    headerText={intl.formatMessage(messages.name)}
                    headerType="h4"
                    bodyText={intl.formatMessage(messages.oneLinerHeadline)}
                    backgroundColor="#f4f5f7"
                    textColor="#253858"
                    clickableCardUrl={url ?? ""}
                    pictureProps={{
                        image: {
                            src: template.templateIcon?.url ?? "",
                            alt:
                                intl.formatMessage(messages.iconDescription) ??
                                ""
                        }
                    }}
                />
            </a>
        );
    }

    return null;
};
